// Phase 11H runtime-config pattern (brought to client-portal parity with the
// staff portal).
//
// server.js injects window.__BABOMRS_CONFIG__ from the client App Service env
// vars per environment; the single build artifact then targets the right API
// (and, via msalConfig, the right Entra app registration) on dev/staging/prod.
// Falls back to the build-baked VITE_API_BASE_URL, then same-origin ('').
//
// Use `||` not `??`: server.js sets values to "" when the env var is unset.
const runtime = window.__BABOMRS_CONFIG__ ?? {};

export const apiBaseUrl: string =
  runtime.apiBaseUrl || import.meta.env.VITE_API_BASE_URL || '';

// Story #15948 (B1) — the sign-in authority is now runtime-sourced too. It used to be derived
// in msalConfig as `https://login.microsoftonline.com/${tenantId}`, which hard-wired the SPA to
// the workforce tenant; client-portal sign-in moved to the Entra External ID (CIAM) tenant, whose
// authority host is `<tenant>.ciamlogin.com` and cannot be built from a tenant id alone.
// No fallback: an unset authority must fail visibly rather than silently resolve to a
// workforce endpoint that will refuse every client.
export const authority: string =
  runtime.authority || import.meta.env.VITE_ENTRA_AUTHORITY || '';
